// src/admin/components/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { db } from '../../common/firebase';
import { collection, getDocs } from 'firebase/firestore/lite';
import '../styles/Dashboard.css';

export default function Dashboard() {
  const [stats, setStats] = useState({
    totalInquiries: 0,
    unreadInquiries: 0,
    todayInquiries: 0,
    recentInquiries: []
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const snap = await getDocs(collection(db, 'contacts'));
      const inquiries = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const todayCount = inquiries.filter(item => {
        if (!item.createdAt?.toDate) return false;
        const itemDate = item.createdAt.toDate();
        itemDate.setHours(0, 0, 0, 0);
        return itemDate.getTime() === today.getTime();
      }).length;

      // 최신 5개 문의
      const recent = inquiries
        .sort((a, b) => {
          const tA = a.createdAt?.seconds || 0;
          const tB = b.createdAt?.seconds || 0;
          return tB - tA;
        })
        .slice(0, 5);

      setStats({
        totalInquiries: inquiries.length,
        unreadInquiries: inquiries.filter(item => !item.checked).length,
        todayInquiries: todayCount,
        recentInquiries: recent
      });
    } catch (err) {
      console.error('대시보드 데이터 로드 실패:', err);
    }
  };

  return (
    <section className="admin-wrap">
      <div className="admin-header">
        <h2>TravelMate 대시보드</h2>
      </div>
      
      {/* 통계 카드 */}
      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>전체 문의</h3>
          <div className="stat-number">{stats.totalInquiries}</div>
        </div>
        <div className="stat-card unread">
          <h3>미읽음 문의</h3>
          <div className="stat-number">{stats.unreadInquiries}</div>
        </div>
        <div className="stat-card today">
          <h3>오늘 문의</h3>
          <div className="stat-number">{stats.todayInquiries}</div>
        </div>
      </div>

      {/* 최근 문의 목록 */}
      <div className="recent-inquiries">
        <h3>최근 문의</h3>
        {stats.recentInquiries.length > 0 ? (
          <div className="inquiry-list">
            {stats.recentInquiries.map(item => (
              <div key={item.id} className={`inquiry-item ${!item.checked ? 'unread' : ''}`}>
                <div className="inquiry-info">
                  <strong>{item.name}</strong>
                  <span className="email">{item.email}</span>
                </div>
                <div className="inquiry-subject">{item.subject}</div>
                <div className="inquiry-date">
                  {item.createdAt?.toDate ? item.createdAt.toDate().toLocaleDateString() : ''}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>문의가 없습니다.</p>
        )}
      </div>
    </section>
  );
}
